interface CoreValue {
  unique_id: string;
  value_en_us: string;
  value_nl_nl: string;
  explanation_en_us: string;
  explanation_nl_nl: string;
  sequence_number: number;
}

interface HydrateOptions {
  element: HTMLElement;
  props?: Record<string, unknown>;
}

type HydrateFn = (options: HydrateOptions) => Promise<void>;

async function bootstrap(): Promise<void> {
  const container = document.getElementById("quiz-island");
  if (!container) {
    console.error("[Core Values POC] Missing #quiz-island container");
    return;
  }

  try {
    const [{ hydrate }, valuesResponse] = await Promise.all([
      import(new URL("./quiz.js", import.meta.url).toString()) as Promise<{ hydrate: HydrateFn }>,
      fetch(new URL("../data/core_values.json", import.meta.url).toString(), {
        headers: { "Accept": "application/json" },
      }),
    ]);

    if (!valuesResponse.ok) {
      throw new Error(`Failed to load values: HTTP ${valuesResponse.status}`);
    }

    const values = await valuesResponse.json() as CoreValue[];
    await hydrate({
      element: container,
      props: {
        values,
        phase2Threshold: 16,
        maxFinalRanking: 10,
      },
    });
  } catch (error) {
    console.error("[Core Values POC] bootstrap failed", error);
    container.innerHTML =
      '<div class="error">Failed to load Core Values Quiz. Please refresh and try again.</div>';
  }
}

void bootstrap();
